import { AssetDto, AssetVersionDto } from '@nusign/picflow-backend-types';

export const isImagesBucketAsset = (asset: AssetDto, version: AssetVersionDto): boolean => {
  if (!asset) return false;
  if (asset.type !== 'image') return false;
  return version.original_key.startsWith('original/');
};
